export const goLiveChecklistMarkdown = `# Go-Live Checklist

Use this checklist before enabling a production ERP integration with CimmplePay.

## Environment and security

- [ ] Production base URL confirmed
- [ ] HTTPS certificate valid
- [ ] Integration user created with least-required permissions
- [ ] Credentials rotation policy defined
- [ ] Sensitive data masking in logs enabled

## API connectivity and auth

- [ ] Login endpoint tested successfully
- [ ] Bearer token included in authenticated requests
- [ ] Multi-company behavior tested (if applicable)
- [ ] Unauthorized and forbidden responses handled correctly

## Data mapping

- [ ] Company id mapping validated
- [ ] Employee id mapping validated
- [ ] Payroll run id mapping validated
- [ ] Monetary values mapped with correct decimal precision
- [ ] Date/time handling validated in UTC and local payroll context

## Functional validation

- [ ] Employee synchronization tested
- [ ] Payroll run create/update/process/finalize tested
- [ ] Payroll output retrieval tested (pay/tax/accounting)
- [ ] ERP journal preview/sync tested (if enabled)
- [ ] Retry behavior tested for transient failures

## Operational readiness

- [ ] Monitoring and alerting configured
- [ ] Partner support contact path documented
- [ ] Incident runbook prepared
- [ ] Rollback/disable procedure prepared

## Documentation readiness

- [ ] Public docs URL published
- [ ] Endpoint examples validated against current API
- [ ] Changelog process defined
- [ ] Internal owner assigned for doc updates
`;
